type Props = {
  error: unknown;
  resetErrorBoundary: () => void;
};

export const Fallback = (props: Props) => {
  const { error } = props;
  console.error({ error });
  // const { name, message } = (() => {
  //   if (error instanceof Error) {
  //     return { name: error.name, message: error.message };
  //   }

  //   return { name: "Something went wrong", message: `${error}` };
  // })();
  return (
    <div className="flex h-full grow flex-col items-center justify-center bg-cover bg-center">
      Error
    </div>
  );
};
